"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Call = _interopRequireDefault(require("../Call"));

var _Location = _interopRequireDefault(require("../Location"));

var _Email = _interopRequireDefault(require("../Email"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var ContactRail = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ContactRail, _React$Component);

  var _super = _createSuper(ContactRail);

  function ContactRail() {
    (0, _classCallCheck2["default"])(this, ContactRail);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ContactRail, [{
    key: "renderCallToAction",
    value: function renderCallToAction(type, props) {
      var _this$props = this.props,
          buttonColor = _this$props.buttonColor,
          iconsOnly = _this$props.iconsOnly;
      var manifestation = iconsOnly ? 'icon' : 'button';

      if (type === 'call') {
        return /*#__PURE__*/_react["default"].createElement(_Call["default"], (0, _extends2["default"])({
          key: type,
          as: manifestation,
          buttonColor: buttonColor,
          showIcon: true
        }, props));
      }

      if (type === 'location') {
        return /*#__PURE__*/_react["default"].createElement(_Location["default"], (0, _extends2["default"])({
          key: type,
          as: manifestation,
          buttonText: iconsOnly ? '' : 'Find us on Google Maps',
          buttonColor: buttonColor
        }, props));
      }

      if (type === 'email') {
        return /*#__PURE__*/_react["default"].createElement(_Email["default"], (0, _extends2["default"])({
          key: type,
          as: manifestation,
          buttonColor: buttonColor,
          showIcon: true
        }, props));
      }

      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          items = _this$props2.items,
          grouped = _this$props2.grouped;
      return grouped ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button.Group, {
        vertical: vertical,
        style: {
          borderRadius: '0em'
        }
      }, items.map(function (_ref) {
        var type = _ref.type,
            props = _ref.props;
        return _this.renderCallToAction(type, props);
      })) : /*#__PURE__*/_react["default"].createElement("div", null, vertical ? items.map(function (_ref2) {
        var type = _ref2.type,
            props = _ref2.props;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: type,
          style: {
            marginBottom: '0.25em'
          }
        }, _this.renderCallToAction(type, props));
      }) : items.map(function (_ref3) {
        var type = _ref3.type,
            props = _ref3.props;
        return _this.renderCallToAction(type, props);
      }));
    }
  }]);
  return ContactRail;
}(_react["default"].Component);

exports["default"] = ContactRail;
ContactRail.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].oneOf(['call', 'location', 'email']),
    props: _propTypes["default"].object
  })).isRequired,
  buttonColor: _propTypes["default"].string,
  circular: _propTypes["default"].bool,
  grouped: _propTypes["default"].bool,
  iconsOnly: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool
};
ContactRail.defaultProps = {
  buttonColor: 'primary',
  circular: false,
  grouped: false,
  iconsOnly: false,
  vertical: false
};